export default {
  partners: [],
  loadingPartners: true,
};
  